export enum ResourceType {
  Lecture = 'Lecture',
  Livestream = 'Livestream',
  EventSponsor = 'EventSponsor',
  EventChatChannel = 'EventChatChannel',
}
